/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Descriptions, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import API from "../../api/backend/workReport";
import GroupItem from "../../component/Desktop/groupItem";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import {
  COMMON_CONSTANT,
  KEY,
  MODE_SCREEN,
  STYLE,
  lang,
} from "../../constants/common.const";

import {
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseCircleOutlined,
  CloudDownloadOutlined,
  ExclamationCircleOutlined,
  FileDoneOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { config } from "@src/api/config";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  handleCatchError,
  MSG_CATCH,
  showMessage,
  statusRes,
} from "../../constants/utils";

import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { workReportNewEquipmentApi } from "../../api/backend/reportNewEquipment";
import classBtn from "../../models/control/button";
import classCheckbox from "../../models/control/checkbox";
import classDdl from "../../models/control/dropdownlist";
import classPopup from "../../models/control/popup";
import classText from "../../models/control/text";
import { checkRoleScreen } from "../../utils/roles";
import ReportMachineForm, { reportDataOrigin } from "./reportMachine";
import { TagVideoList } from "../../component/video/TagVideoList";
import { CloudCross } from "iconsax-react";

//Declare global variables
export const REPORT_TYPE = [
  { id: "1", name: "作業報告" },
  { id: "2", name: "トラブル報告" },
];

function ViewWorkReport() {
  let { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  let [initPage, setInitPage] = useState(true);
  let [showLoading, setShowLoading] = useState(false);
  const { allowRoute, roleKey } = useSelector((state) => state.auth);
  const [tags,setTags] = useState([])
  const [listAllTag,setListAllTag] = useState([])
  const location = useLocation();

  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  // Group 1
  let [txtName, settxtName] = useState(new classText());
  let [ddlReportType, setddlReportType] = useState(new classDdl());
  const [ddlReportTypeCode, setddlReportTypeCode] = useState(new classDdl());
  let [ddlPriority, setddlPriority] = useState(new classDdl());
  let [txtStatus, settxtStatus] = useState(new classText());

  let [peConfirm, setpeConfirm] = useState(new classText());
  let [peApprove, setpeApprove] = useState(new classText());
  const [reportData, setReportData] = useState(
    JSON.parse(JSON.stringify(reportDataOrigin))
  );
  const [reportDataEdit, setReportDataEdit] = useState(
    JSON.parse(JSON.stringify(reportDataOrigin))
  );
  const [listImage, setListImage] = useState([]);
  const [listAttachMachine, setListAttachMachine] = useState([]);

  // Group 2
  let [dataMachine, setdataMachine] = useState([]);
  let [rowShow, setrowShow] = useState([]);

  let [txtTroubleInformation, settxtTroubleInformation] = useState(
    new classText()
  );
  let [txtRenovationMethod, settxtRenovationMethod] = useState(new classText());
  let [txtReason, settxtReason] = useState(new classText());
  const [chkAutoExport, setChkAutoExport] = useState(new classCheckbox());

  // Btn
  let [btnConfirm, setbtnConfirm] = useState(new classBtn());
  let [btnResolve, setbtnResolve] = useState(new classBtn());
  let [btnApprove, setbtnApprove] = useState(new classBtn());
  let [btnReject, setbtnReject] = useState(new classBtn());

  // Popup
  let [popupAttach, setPopupAttach] = useState(new classPopup());
  let [popupConfirm, setPopupConfirm] = useState(new classPopup());
  // In-Popup
  let [tblAttach, setTblAttach] = useState([]);
  let [txtReasonInput, settxtReasonInput] = useState(new classText());

  function formatTimestampToDate(timestamp, format) {
    if (!timestamp) return null;
    return moment.unix(Number(timestamp)).format(format || "YYYY-MM-DD");
  }
  function formatTimestampToDate2(timestamp) {
    if (!timestamp) return null;
    return moment.unix(Number(timestamp));
  }
  const setDetailEditData = (dataDetail) => {
    const reportDataNew = { ...reportDataEdit };
    reportDataNew.clientName.value = dataDetail.clientName;
    reportDataNew.contractorName.value = dataDetail.contractorName;
    reportDataNew.reportOrInquiry.value = dataDetail.reportOrInquiry;
    reportDataNew.reportCategory.value = dataDetail.reportCategory;
    reportDataNew.equipmentId.value = dataDetail.equipmentId;
    reportDataNew.reportManagementNumber.value =
      dataDetail.reportManagementNumber;
    reportDataNew.createDate.value = formatTimestampToDate2(
      dataDetail.reportDate
    );
    reportDataNew.resubmitDate.value = formatTimestampToDate2(
      dataDetail.resubmissionDate
    );
    reportDataNew.subject.value = dataDetail.subject;
    reportDataNew.facility.value = dataDetail.facilityName;
    reportDataNew.location.value = dataDetail.installLocation;
    reportDataNew.machineForSiteOfficeCode.value =
      dataDetail.machineForSiteOfficeCode;
    reportDataNew.equipmentName.value = dataDetail.machineForSiteOfficeName;
    reportDataNew.modelSpec.value = dataDetail.modelNumber;
    reportDataNew.reporter.value = dataDetail.reporter;
    reportDataNew.manager.value = dataDetail.manager;
    reportDataNew.assistantManager.value = dataDetail.assistantManager;
    reportDataNew.occurrenceDateTime.value = formatTimestampToDate2(
      dataDetail.occurrenceDateTime
    );
    reportDataNew.occurrenceStatus.value = dataDetail.occurrenceStatus;
    reportDataNew.situationDescription.value = dataDetail.situationDescription;
    reportDataNew.simpleRepairStatus.value = dataDetail.simpleRepairStatus;
    reportDataNew.notCompletedProposed.value = dataDetail.notCompletedProposed;
    reportDataNew.contractorMeasuresAction.value =
      dataDetail.contractorMeasuresAction;
    reportDataNew.priority.value = dataDetail.priority;
    reportDataNew.importance.value = dataDetail.important;
    reportDataNew.attachedDocument.value = dataDetail.attachedDocument;
    reportDataNew.quotation.value = dataDetail.quotation;
    reportDataNew.clientResponseDate.value = formatTimestampToDate2(
      dataDetail.clientResponseDate
    );
    reportDataNew.clientResponse.value = dataDetail.clientResponse;
    reportDataNew.clientSeal.value = dataDetail.clientSeal;
    reportDataNew.discussionResult.value = dataDetail.discussionResult;
    reportDataNew.additionalApprover.value = dataDetail.additionalApprover;

    setReportDataEdit(reportDataNew);
  };

  const setDetailEquipment = (dataDetail) => {
    const reportDataNew = { ...reportData };
    reportDataNew.clientName.value = dataDetail.clientName;
    reportDataNew.contractorName.value = dataDetail.contractorName;
    reportDataNew.reportOrInquiry.value = dataDetail.reportOrInquiryValue;
    reportDataNew.reportCategory.value = dataDetail.reportCategoryValue;
    reportDataNew.equipmentId.value = dataDetail.equipmentId;
    reportDataNew.reportManagementNumber.value =
      dataDetail.reportManagementNumber;
    reportDataNew.createDate.value = formatTimestampToDate(
      dataDetail.reportDate
    );
    reportDataNew.resubmitDate.value = formatTimestampToDate(
      dataDetail.resubmissionDate
    );
    reportDataNew.subject.value = dataDetail.subject;
    reportDataNew.facility.value = dataDetail.facilityName;
    reportDataNew.location.value = dataDetail.installLocation;
    reportDataNew.machineForSiteOfficeCode.value =
      dataDetail.machineForSiteOfficeCode;
    reportDataNew.equipmentName.value = dataDetail.machineForSiteOfficeName;
    reportDataNew.modelSpec.value = dataDetail.modelNumber;
    reportDataNew.reporter.value = dataDetail.reporterName;
    reportDataNew.manager.value = dataDetail.managerName;
    reportDataNew.assistantManager.value = dataDetail.assistantManagerName;
    reportDataNew.occurrenceDateTime.value = formatTimestampToDate(
      dataDetail.occurrenceDateTime,
      "YYYY/MM/DD HH:mm:ss"
    );
    reportDataNew.occurrenceStatus.value = dataDetail.occurrenceStatusValue;
    reportDataNew.situationDescription.value = dataDetail.situationDescription;
    reportDataNew.simpleRepairStatus.value = dataDetail.simpleRepairStatusValue;
    reportDataNew.notCompletedProposed.value =
      dataDetail.notCompletedProposedValue;
    reportDataNew.contractorMeasuresAction.value =
      dataDetail.contractorMeasuresActionValue;
    reportDataNew.priority.value = dataDetail.priorityValue;
    reportDataNew.importance.value = dataDetail.important;
    reportDataNew.attachedDocument.value = dataDetail.attachedDocumentValue;
    reportDataNew.quotation.value = dataDetail.quotation;
    reportDataNew.clientResponseDate.value = formatTimestampToDate(
      dataDetail.clientResponseDate
    );
    reportDataNew.clientResponse.value = dataDetail.clientResponseValue;
    reportDataNew.clientSeal.value = dataDetail.clientSeal;
    reportDataNew.discussionResult.value = dataDetail.discussionResultValue;
    reportData.additionalApprover.value = dataDetail.additionalApproverName;

    setReportData(reportDataNew);
    setListImage(dataDetail.listWorkReportImage);
    setListAttachMachine(dataDetail.listWorkReportAttachment);
    setTags(dataDetail.tagLists || [])
  };
  const init = () => {
    setInitPage(true);
    // Open loading
    openLoadingSpinner();

    Promise.all([workReportNewEquipmentApi.getDetail(id)])
      .then((res) => {
        let data = res[0] ? res[0].data : null;
        //Group1
        if (!data) {
          history.push("/WorkReportManagement");
          return;
        }
        // Normal

        settxtName({ ...txtName, value: data.name });
        setddlReportType({
          ...ddlReportType,
          value: data.reportTypeValue,
          valueKey: data.reportType,
        });
        setddlReportTypeCode({ ...ddlReportTypeCode, value: data.reportType });
        ddlPriority.value = data.priorityValue;
        setddlPriority({ ...ddlPriority, value: data.priorityValue });

        settxtStatus({ ...txtStatus, value: data.statusValue });
        peConfirm.value = data.confirmerDisplay;
        setpeConfirm({ ...peConfirm, value: data.confirmerDisplay });

        peApprove.value = data.approverDisplay;
        setpeApprove({ ...peApprove, value: data.approverDisplay });
        //Group2
        settxtRenovationMethod({
          ...txtRenovationMethod,
          value: data.solution,
        });
        txtTroubleInformation.value = data.description;
        settxtTroubleInformation({
          ...txtTroubleInformation,
          value: data.description,
        });
        txtReason.value = data.rejectReason;
        settxtReason({ ...txtReason, value: data.rejectReason });
        setChkAutoExport({ ...chkAutoExport, checked: data.createExport });
        // Table machine
        let show = [];

        setrowShow(show);
        setdataMachine(data.listWorkReportDetail);

        checkShowHideButtonAction(data.status, data.canApprove);

        setDetailEquipment(data);
        setDetailEditData(JSON.parse(JSON.stringify(data)));
        // Pass init
        setInitPage(false);
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        closeLoadingSpinner();
      });
  };

  // Init
  useEffect(checkRoleScreen(location.pathname, allowRoute) && init, [
    allowRoute,
  ]);

  // Config screen
  const checkShowHideButtonAction = (status, canApprove) => {
    if (canApprove) {
      setbtnApprove({ ...btnApprove, show: true });
      setbtnReject({ ...btnReject, show: true });
    } else {
      setbtnApprove({ ...btnApprove, show: false });
      setbtnReject({ ...btnReject, show: false });
    }
    if (status == 5) {
      settxtReason({ ...txtReason, show: true });
    } else {
      settxtReason({ ...txtReason, show: false });
    }
  };

  function backToSearch() {
    history.goBack();
  }

  // DOWNLOAD ALL FILE
  const dowloadAllFile =async () => {
    try {
      openLoadingSpinner()
      const res = await workReportNewEquipmentApi.dowloadAllFile(id);
      const blob = new Blob([res.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.target = "_blank";
      const now = moment().format("YYYYMMDDHHmmss");
      link.download = txtName.value + "_" + now +  ".zip";
      link.click();

    } catch (error) {
      handleCatchError(error)
    }
    finally{
      closeLoadingSpinner()
    }
  }

  function showPopupConfirm(mode) {
    mode = String(mode);
    let customTitle = false;
    let title;
    let type;

    if (mode === COMMON_CONSTANT.WORK_REPORT_STATUS_REJECTED) {
      // Reject mode
      settxtReasonInput({ ...txtReasonInput, value: "", error: false });
      customTitle = true;
      title = "この作業報告を拒否してもよろしいですか？";
      type = COMMON_CONSTANT.REJECTED;

      // Show popup
      setPopupConfirm({
        ...popupConfirm,
        show: true,
        title: title,
        customTitle: customTitle,
        type: type,
      });
      return false;
    } else if (mode === COMMON_CONSTANT.WORK_REPORT_STATUS_CONFIRMED) {
      // Confirm mode
      title = "この作業報告を確認してもよろしいですか？";
      type = COMMON_CONSTANT.CONFIRMED;
    } else if (mode === COMMON_CONSTANT.WORK_REPORT_STATUS_APPROVED) {
      // Approve mode
      title = "この作業報告を承認してもよろしいですか？";
      type = COMMON_CONSTANT.APPROVED;
    } else if (mode === COMMON_CONSTANT.WORK_REPORT_STATUS_RESOLVED) {
      // Resolve mode
      title = "この作業報告を完了してもよろしいですか？";
      type = COMMON_CONSTANT.RESOLVED;
    } else {
      // other
    }

    // Show popup
    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.WARMING,
      content: title,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      centered: true,
      onOk: () => {
        changeStatus({
          title: title,
          customTitle: customTitle,
          type: type,
        });
      },
    });
  }

  function changeStatus(data) {
    popupConfirm = data || popupConfirm;

    if (String(popupConfirm.type) === COMMON_CONSTANT.REJECTED) {
      // Validate required
      if (txtReasonInput.value && txtReasonInput.value.trim() !== "") {
        // normal
      } else {
        // error
        settxtReasonInput({ ...txtReasonInput, error: true });
        return false;
      }
    }

    openLoadingSpinner();
    setPopupConfirm({
      ...popupConfirm,
      show: false,
    });

    // Call
    workReportNewEquipmentApi
      .changeStatus({
        id: id,
        Status: popupConfirm.type,
        RejectResson: txtReasonInput.value,
      })
      .then((res) => {
        if (statusRes(res)) {
          init();
          // If reject and resolve => change status of office
          if (String(popupConfirm.type) === COMMON_CONSTANT.RESOLVED) {
            // init();
          } else {
            showNotifiPopup(popupConfirm.type);
          }
        } else {
          showMessage(KEY.ERROR, res.data.msg);
        }
      })
      .catch((err) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        // Close
        closeLoadingSpinner();
      });
  }

  function showNotifiPopup(mode) {
    mode = String(mode);
    let title;

    if (mode === COMMON_CONSTANT.REJECTED) {
      // Reject mode
      title = lang.REJECT_CHECKLIST_SUCCESS;
    } else if (mode === COMMON_CONSTANT.CONFIRMED) {
      // Confirm mode
      title = lang.CONFIRM_CHECKLIST_SUCCESS;
    } else if (mode === COMMON_CONSTANT.APPROVED) {
      // Approve mode
      title = lang.APPROVE_CHECKLIST_SUCCESS;
    } else if (mode === COMMON_CONSTANT.RESOLVED) {
      // Resolve mode
      title = lang.SOLVED_NORMALLY;
    } else {
      // Empty
    }
    showMessage(KEY.INFO, title);
  }
  const openNewHistoryDetail = (router) => {
    window.open(config.clientEndpoint + router);
  };

  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    let callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };
  async function handleSaveNewReportEquipment() {
    if(reportDataEdit.additionalApprover.value && reportDataEdit.additionalApprover.value === reportDataEdit.assistantManager.value){
      setReportDataEdit({
        ...reportDataEdit,
        additionalApprover:{
          ...reportDataEdit.additionalApprover,
          error:true
        }
      })
      return;
    }
    showConfirmMessage(COMMON_CONSTANT.BOM_C009, async function () {
      openLoadingSpinner();
      const body = {
        checkResultId: "",
        listMachineInfo: [
          {
            machineForSiteOfficeCode:
              reportDataEdit.machineForSiteOfficeCode.value,
            machineForSiteOfficeName: reportDataEdit.equipmentName.value,
            lstBuhin: [],
          },
        ],
        listAttachment: listAttachMachine.map((att, index) => ({
          ...att,
          itemOrder: index + 1,
        })),
        name: txtName.value,
        reportType: ddlReportType.valueKey,
        priority: reportDataEdit.priority.value,
        // confirmer:null,
        // mailConfirm: null,
        // approver:  null,
        // mailApprove: null,
        description: txtTroubleInformation.value,
        solution: txtRenovationMethod.value,
        createId: reportDataEdit.createId,
        // createExport: false,
        reportDate: reportDataEdit.createDate.value
          ? moment(reportDataEdit.createDate.value).unix()
          : null,
        clientName: reportDataEdit.clientName.value,
        contractorName: reportDataEdit.contractorName.value,
        reportOrInquiry: reportDataEdit.reportOrInquiry.value,
        reportCategory: reportDataEdit.reportCategory.value,
        equipmentId: reportDataEdit.equipmentId.value,
        reportManagementNumber: reportDataEdit.reportManagementNumber.value,
        resubmissionDate: reportDataEdit.resubmitDate.value
          ? moment(reportDataEdit.resubmitDate.value).unix()
          : null,
        subject: reportDataEdit.subject.value,
        machineForSiteOfficeCode: reportDataEdit.machineForSiteOfficeCode.value,
        reporter: reportDataEdit.reporter.value,
        manager: reportDataEdit.manager.value,
        assistantManager: reportDataEdit.assistantManager.value,
        occurrenceDateTime: reportDataEdit.occurrenceDateTime.value
          ? moment(reportDataEdit.occurrenceDateTime.value).unix()
          : null,
        occurrenceStatus: reportDataEdit.occurrenceStatus.value,
        situationDescription: reportDataEdit.situationDescription.value,
        simpleRepairStatus: reportDataEdit.simpleRepairStatus.value,
        notCompletedProposed: reportDataEdit.notCompletedProposed.value,
        contractorMeasuresAction: reportDataEdit.contractorMeasuresAction.value,
        important: reportDataEdit.importance.value,
        attachedDocument: reportDataEdit.attachedDocument
          ? reportDataEdit.attachedDocument.value
          : "",
        quotation: reportDataEdit.quotation.value,
        clientResponseDate: reportDataEdit.clientResponseDate.value
          ? moment(reportDataEdit.clientResponseDate.value).unix()
          : null,
        clientResponse: reportDataEdit.clientResponse.value,
        clientSeal: reportDataEdit.clientSeal.value,
        discussionResult: reportDataEdit.discussionResult.value,
        listImage: listImage.map((image, index) => ({
          ...image,
          itemOrder: index + 1,
        })),
        additionalApprover: reportDataEdit.additionalApprover.value,
        tagLists:tags
      };
      try {
        await workReportNewEquipmentApi.updateReport(id, body);
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
          init()
        });
      } catch (error) {
        handleCatchError(error);
      } finally {
        closeLoadingSpinner();
      }
    });
  }
  return (
    <div className="des-content">
      <Loading show={showLoading}></Loading>
      <TitlePage name={lang.WORK_REPORT_INFORMATION} />

      {/* Group 1 */}
      <GroupItem name={lang.REPORT_INFO} center>
        <div className="mt15"></div>

        <Descriptions
          className="customEquipmentDes"
          size="small"
          column={2}
          bordered
        >
          <Descriptions.Item
            label={
              <span className="labelInputEquipment">{lang.REPORT_NAME}</span>
            }
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
            <div className="white-space">{txtName.value}</div>
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <span className="labelInputEquipment">{lang.REPORT_LEVEL}</span>
            }
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
            <div className="white-space">{ddlReportType.value}</div>
          </Descriptions.Item>
          <Descriptions.Item
            label={<span className="labelInputEquipment">{lang.STATUS}</span>}
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
            <div className="white-space"> {txtStatus.value}</div>
          </Descriptions.Item>
          <Descriptions.Item
            label={<span className="labelInputEquipment">{"参照動画"}</span>}
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
           <TagVideoList tags={tags} />
          </Descriptions.Item>
        </Descriptions>

        <div className="mt15"></div>
        <ReportMachineForm
          mode={MODE_SCREEN.VIEW}
          reportData={reportData}
          listAttachMachine={listAttachMachine}
          listImage={listImage}
          showApprove={reportData.additionalApprover.value}
          showBtn={btnApprove.show && !reportData.additionalApprover.value}
          customChangeAdded={(v) =>
            setReportDataEdit({
              ...reportDataEdit,
              additionalApprover: {
                ...reportDataEdit.additionalApprover,
                value: v,
              },
            })
          }
          customValueAdded={
            btnApprove.show && !reportData.additionalApprover.value
              ? reportDataEdit.additionalApprover
              : ""
          }
        />

        <div className="mt15"></div>

        <Descriptions
          className="customEquipmentDes"
          size="small"
          column={2}
          bordered
        >
          <Descriptions.Item
            label={
              <span className="labelInputEquipment">
                {lang.PRECAUTION_TROUBLE_DETAIL}
              </span>
            }
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
            <div className="white-space">{txtTroubleInformation.value}</div>
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <span className="labelInputEquipment">
                {lang.SAVE_REPORT + "・" + lang.REPAIR_METHOD}
              </span>
            }
            span={2}
            labelStyle={{ fontWeight: "bold", width: "22%" }}
            contentStyle={{ padding: "4px 4px" }}
          >
            <div className="white-space">{txtRenovationMethod.value}</div>
          </Descriptions.Item>

          {txtReason.show && (
            <Descriptions.Item
              label={
                <span className="labelInputEquipment">
                  {lang.REASON_FOR_REJECT}
                </span>
              }
              span={2}
              labelStyle={{ fontWeight: "bold", width: "22%" }}
              contentStyle={{ padding: "4px 4px" }}
            >
              <div className="white-space">{txtReason.value}</div>
            </Descriptions.Item>
          )}
        </Descriptions>

        <Row justify="end" className="mt10 mb10">
          {!initPage && (
            <>
              <>
                {btnApprove.show && !reportData.additionalApprover.value && (
                  <Button
                  disabled={!reportDataEdit.additionalApprover.value}
                    className="buttonPC button--info wAuto ml15"
                    onClick={() => {
                      handleSaveNewReportEquipment();
                    }}
                  >
                    <SaveOutlined />
                    {COMMON_CONSTANT.SAVE}
                  </Button>
                )}

                {/* btnReject */}
                {btnReject.show && (
                  <Button
                    className="buttonPC button--info wAuto ml15"
                    onClick={() => {
                      showPopupConfirm(
                        COMMON_CONSTANT.WORK_REPORT_STATUS_REJECTED
                      );
                    }}
                  >
                    <MinusCircleOutlined />
                    {lang.REJECT}
                  </Button>
                )}
                {/* btnConfirm */}
                {/* {btnConfirm.show && (
                  <Button
                    className="buttonPC button--info wAuto ml15"
                    onClick={() => {
                      showPopupConfirm(
                        COMMON_CONSTANT.WORK_REPORT_STATUS_CONFIRMED
                      );
                    }}
                  >
                    <CheckSquareOutlined />
                    {lang.CONFIRM}
                  </Button>
                )} */}
                {/* btnApprove */}
                {btnApprove.show && (
                  <Button
                    className="buttonPC button--info wAuto ml15"
                    onClick={() => {
                      showPopupConfirm(
                        COMMON_CONSTANT.WORK_REPORT_STATUS_APPROVED
                      );
                    }}
                  >
                    <CheckCircleOutlined />
                    {lang.APPROVE}
                  </Button>
                )}
              </>
              {/* btnResolve */}
              {/* {btnResolve.show && (
                <Button
                  className="buttonPC button--info wAuto ml15"
                  onClick={() => {
                    showPopupConfirm(
                      COMMON_CONSTANT.WORK_REPORT_STATUS_RESOLVED
                    );
                  }}
                >
                  <FileDoneOutlined />
                  {lang.RESOLVE}
                </Button>
              )} */}
              {/* Back */}
            </>
          )}
           <Button
            className="buttonPC button--info wAuto ml15"
            onClick={dowloadAllFile}
          >
            <CloudDownloadOutlined />
            {lang.EXPORT}
          </Button>
          <Button
            className="buttonPC button--outline --todo-- wAuto ml15"
            onClick={backToSearch}
          >
            <CloseCircleOutlined />
            {lang.CLOSE}
          </Button>
        </Row>
      </GroupItem>

      {/* Popup confirm */}
      <Modal
        centered
        closeIcon={<></>}
        className="modal-msg modal-warning2"
        title={
          <>
            <ExclamationCircleOutlined />
            <div className="modal-custom-content">
              {popupConfirm.title}
              {popupConfirm.customTitle && (
                <>
                  <Row>
                    <span className="fs12 pt5 mb5">
                      {lang.REASON_FOR_REJECT}
                      <label className="blod ml5 mark-required">*</label>
                    </span>
                  </Row>
                  <Row>
                    <TextArea
                      rows={3}
                      className={txtReasonInput.error ? STYLE.BORDER_RED : ""}
                      maxLength={255}
                      value={txtReasonInput.value}
                      onChange={(e) => {
                        settxtReasonInput({
                          ...txtReasonInput,
                          value: e.target.value,
                          error: false,
                        });
                      }}
                    />
                  </Row>
                </>
              )}
            </div>
          </>
        }
        visible={popupConfirm.show}
        footer={[
          <Button
            key={2}
            onClick={() => {
              setPopupConfirm({ ...popupConfirm, show: false });
            }}
          >
            {lang.CANCEL}
          </Button>,
          <Button
            key={1}
            className="buttonPC button--warning2 wAuto"
            onClick={() => {
              changeStatus();
            }}
          >
            {lang.OK}
          </Button>,
        ]}
      ></Modal>
    </div>
  );
}

export default ViewWorkReport;
